module.exports = __webpack_public_path__ + "img/Menu.8807e9b0.svg";